import type { FunctionComponent } from 'react';
import GenericInfoDTO from '../../../interfaces/dto/genericInfoDTO';
import Question from '../../../interfaces/question';
import { subQuestionStyles } from '../../../utils/subQuestionStyles';
import { ChosenOptionAnswer } from '../../context/SurveyPageContext';
import RadioOption from './RadioOption';
import * as styles from './RadioButton.module.css';

export interface RadioButtonProps {
  question: Question;
  onChange: ({
    newOption,
    isOtherOption,
  }: {
    newOption: GenericInfoDTO;
    isOtherOption: boolean;
  }) => void;
  radioButtonAnswer: ChosenOptionAnswer | undefined;
  additionalText: string | null;
  onChangeInputText: ({ newContent }: { newContent: string }) => void;
}

const RadioButton: FunctionComponent<RadioButtonProps> = ({
  question,
  onChange,
  radioButtonAnswer,
  additionalText,
  onChangeInputText,
}) => {
  const { isSubQuestion } = question;
  const options = question.radioButtonOptions;
  const radioOptionId = radioButtonAnswer?.chosenOption?.id;
  const amountOfOptions = options.length;
  const lastOption = options[amountOfOptions - 1];

  const inputTextOption: GenericInfoDTO = {
    id: lastOption.id + 1,
    position: amountOfOptions,
    weight: null,
    description: 'Other',
    value: '',
    conditionalQuestionId: null,
    insertedAt: '',
    updatedAt: '',
  };

  return (
    <div
      className={`${styles.radioContainer} ${subQuestionStyles({
        styles,
        isSubQuestion,
      })}`}
    >
      {options.map((option) => (
        <RadioOption
          option={option}
          questionId={question.id}
          isSubQuestion={question.isSubQuestion}
          onChange={onChange}
          checked={radioOptionId === option.id}
          key={`radioOption-${option.id}`}
          additionalText={null}
          isOtherOption={false}
          grayedOut={!!(radioOptionId && radioOptionId !== option.id)}
        />
      ))}
      {question.enableOtherChoice && (
        <RadioOption
          option={inputTextOption}
          questionId={question.id}
          isSubQuestion={question.isSubQuestion}
          onChange={onChange}
          checked={additionalText !== null}
          key={`radioOption-${inputTextOption.id}`}
          additionalText={additionalText}
          isOtherOption
          onChangeInputText={onChangeInputText}
          grayedOut={!!radioOptionId}
        />
      )}
    </div>
  );
};

export default RadioButton;
